export enum DocuSignTab {
  Credentials = 'credentials',
  Templates = 'templates',
}
